import { Grid, Pagination } from '@mui/material';
import React from 'react';

import { WsTypography, WsTypoVariants, WsTypoColors } from '../WsTypography';

export interface WsPaginationProps {
  count: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  totalCount?: number;
  pageNumber?: number;
  itemsPerPage?: number;
  isPageCount?: boolean;
  type?: string;
  defaultPage?: number;
  textCursorType?: 'pointer' | 'text' | 'no-drop';
}

const WsPagination = ({
  count,
  onChange,
  pageNumber = 0,
  itemsPerPage = 20,
  isPageCount = false,
  totalCount = 0,
  type,
  defaultPage,
  textCursorType = 'pointer',
}: WsPaginationProps) => (
  <Grid item xs={12} justifyContent="space-between" alignItems="center" container>
    <Grid item xs={6} container ml={2}>
      {isPageCount && (
        <WsTypography
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.BLACK}
          cursor={textCursorType}
        >{`${pageNumber * itemsPerPage + 1} - ${
          totalCount >= (pageNumber + 1) * itemsPerPage
            ? (pageNumber + 1) * itemsPerPage
            : totalCount
        } of ${totalCount} ${type}`}</WsTypography>
      )}
    </Grid>
    <Pagination
      color="primary"
      count={count}
      variant="outlined"
      shape="rounded"
      page={defaultPage}
      onChange={(e, ind) => {
        ind > 0 ? onChange(e, ind - 1) : onChange(e, ind);
      }}
    />
  </Grid>
);

export default WsPagination;
